import { Injectable } from "@angular/core";
import { asyncScheduler, Subject } from "rxjs";
import { observeOn } from "rxjs/operators";
import { v4 as uuid } from "uuid";

@Injectable()
export class ErrorHandlerService {
  private readonly _error$ = new Subject<Error1>();

  get error$() {
    return this._error$.asObservable().pipe(observeOn(asyncScheduler));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error(error: any) {
    this._error$.next({
      error,
      errorId: uuid()
    });
  }
}

export interface Error1 {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error: any;
  errorId: string;
}
